import Navbar from "../components/Navbar";
import Career from "../components/Career";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Warning from "../components/Warning";
import Banner from "../components/Banner";
function CareersPage() {
  return (
    <>
      <section className="hidden lg:block">
          <Banner />
        <Navbar />
      <Warning/>

      </section>
      <section className="block lg:hidden">
        <Sidebar />
      </section>
      <Career />
      <Footer />
    </>
  );
}

export default CareersPage;
